import { Breakpoints } from '@/settings/breakpoints';

export const defaultSmallBreakpoints = {
  [Breakpoints.NONE]: {
    slidesPerView: 1.1,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.XXXS]: {
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.XXS]: {
    slidesPerView: 1.75,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.XS]: {
    slidesPerView: 2.5,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.SM]: {
    slidesPerView: 3.25,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.MD]: {
    slidesPerView: 3.6,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.LG]: {
    slidesPerView: 5,
    slidesPerGroup: 5,
    spaceBetween: -1,
  },
  [Breakpoints.XL]: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: -1,
  },
};

export const defaultBreakpointsV2 = {
  [Breakpoints.NONE]: {
    slidesPerView: 1.1,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.XXXS]: {
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.XXS]: {
    slidesPerView: 1.75,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.XS]: {
    slidesPerView: 2.5,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.SM]: {
    slidesPerView: 3.25,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.MD]: {
    slidesPerView: 3.6,
    slidesPerGroup: 1,
    spaceBetween: -1,
  },
  [Breakpoints.LG]: {
    slidesPerView: 5,
    slidesPerGroup: 5,
    spaceBetween: -1,
  },
  [Breakpoints.XL]: {
    slidesPerView: 6,
    slidesPerGroup: 6,
    spaceBetween: -1,
  },
};
